(function(root, factory) {
	if (typeof define === 'function' && define.amd) {
		define('storeService', ['repositoryService','statusService'], function(repositoryService, userService) {
			return factory(root, repositoryService, userService);
		});
	} else {
		 root.StoreService = factory(root, repositoryService, userService);
	}
})(this, function(root, repositoryService, userService) {

	/**
	 * @constant
	 * @type {String}
	 */
	var storeStorageKey = 'THD_LOCSTORE';

	/**
	 * @member
	 * @description Default store #121 details
	 * @type {object}
	 */
	var defaultStore =  {
        storeId: '121',
        name: 'Cumberland',
        address: {
          postalCode: '30339',
          county: 'Cobb',
          state: 'GA',
          country: 'US',
          city: 'Atlanta',
          street: '2450 Cumberland Pkwy'
        },
        storeHours: {
          monday: { open: '6:00', close: '21:00' },
          tuesday: { open: '6:00', close: '21:00' },
          wednesday: { open: '6:00', close: '21:00' },
          thursday: { open: '6:00', close: '21:00' },
          friday: { open: '6:00', close: '21:00' },
          saturday: { open: '6:00', close: '21:00' },
          sunday: { open: '8:00', close: '19:00' }
        }
      };

  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

	var mapStoreHoursToString = function(storeHours) {
		var storeHoursInString = days.map(function(day, index) {
			return (index + 1) + ';' + storeHours[day].open + '-' + storeHours[day].close;
		}).reduce(function(concatenatedStoreHours, storeHours) {
			return concatenatedStoreHours ? (concatenatedStoreHours + ';' + storeHours) : storeHours;
		});
		return storeHoursInString;
	};

	var mapStringToStoreHours = function(storeHoursInString) {
		var storeHours = {};
		storeHoursInString
					.split(';')
					.filter(function(value, index) {
						return index %2 !== 0;
					}).map(function(openCloseHours) {
						var hours = openCloseHours.split('-');
						return {
							'open': hours[0], 'close' : hours[1]
						}
					}).forEach(function(openCloseHours, index) {
						var day = days[index];
						storeHours[day] = openCloseHours;
					});
		return storeHours;
	};

  /**
   * @module StoreService
   * @description Provides methods to get/set/remove store details in json format.
   * @type {Object}
   */
	var storeService = {

		/**
		 * @function GetDefaultStore
		 * @description Returns the default store details #121
		 * @return {object} Returns the default store #121
		 */
		getDefaultStore: function() {
			return defaultStore;
		},

		/**
		 * @function SetDefaultStore
		 * @description Persists default store #121
		 */
		setDefaultStore: function() {
			this.setStore(defaultStore);
		},

		/**
		 * @function SetStore
		 * @description Converts the subset of store information(json) to string format and
		 * persists in storage.
		 * @param {object} store - store to be persisted.
		 * @param {string} storageStrategy Optional parameter allows consumer to specify the storage method.
		 */
		setStore: function(store) {
			var workflow = userService.status.getWorkflow();
			var fixedStoreId = store.storeId.replace(/^0/, '');

			var storeDetails = JSON.stringify({
				storeId: fixedStoreId,
				name: store.name,
				street: store.address && store.address.street,
				city: store.address && store.address.city,
				state: store.address && store.address.state,
				zipcode: store.address && store.address.postalCode
			});
			var oneYearInMilliSeconds = 365*24*60*60*1000;
			// will be stored in C4. Hence the below transormation.
			storeDetails = fixedStoreId + '+' + store.name + ' - ' + store.address.city + ', ' + store.address.state + '+',
			repositoryService.put(storeStorageKey, storeDetails, workflow);
			// Store hours and zip code added to support migration.
			// These two cookies should be removed in future.
			repositoryService.put('THD_STRFINDERZIP', store.address.postalCode);
			// Whenever user is localized to a store, default the store zip code as delivery zip. (for Regional Assorment MVP1)
			// This cookie will be used across .com to calculate assortment and delivery options
			repositoryService.put('DELIVERY_ZIP', store.address.postalCode);
			var storeHoursInString = mapStoreHoursToString(store.storeHours);
			repositoryService.put('THD_STORE_HOURS', storeHoursInString);
			// if store user self localizes to different store, update store_info expiration
			if(userService.status.isUserInStore()) {
				if(userService.status.isSelfLocalized()) {
						var existingStoreDetails = repositoryService.get('THD_STORE_INFO');
						repositoryService.put('THD_STORE_INFO', existingStoreDetails, workflow); // same store, update expiration
				} else if(userService.status.isAutoLocalized()) {
						repositoryService.put('THD_STORE_INFO', storeDetails, workflow);
				}
			}
		},

		/**
		 * @function GetStore
		 * @description Reads the store details from storage, Parses to JSON.
		 * @param {string} storageStrategy Optional parameter allows consumer to specify the storage method.
		 * @return {object} Returns the store
		 */
		getStore: function(workflow) {
			var workflow = userService.status.getWorkflow();
			var store = workflow && repositoryService.get(storeStorageKey, workflow);
			var zipCode = repositoryService.get('THD_STRFINDERZIP');
			var storeHours = repositoryService.get('THD_STORE_HOURS');
			storeHours = storeHours && mapStringToStoreHours(storeHours);

			if(store) {
				var storeDetails = store.split('+');

				try {
					var storeNameAndCityState = storeDetails[1];
					var dashCount = storeNameAndCityState.split('-').length - 1;

					if (dashCount === 1) {
						return {
							storeId: storeDetails[0],
							name: storeDetails[1].split('-')[0].trim(),
							city: storeDetails[1].split('-')[1].split(',')[0].trim(),
							state: storeDetails[1].split('-')[1].split(',')[1].trim(),
							zipcode: zipCode,
							storeHours: storeHours
						}
					} else {
						var lastIndexOf = storeNameAndCityState.lastIndexOf(' - ');
						var name = storeNameAndCityState.substr(0, lastIndexOf);
						var cityState = storeNameAndCityState.substr(lastIndexOf + 3); // Add 3 because of lengt of " - "

						return {
							storeId: storeDetails[0],
							name: name,
							city: cityState.split(',')[0].trim(),
							state: cityState.split(',')[1].trim(),
							zipcode: zipCode,
							storeHours: storeHours
						}
					}
				} catch (ex) {
						// *** Remove this catch block post migration ***
						// unfortunately my account persists store details in different format.
						// Ideally my account shouldn't really update store details. This shouldn't happen post migration.
						// Ex: 6553+Howard Lane+-+Austin,+TX+ (Incorrect format)
						return {
							storeId: storeDetails[0],
							name: storeDetails[1].trim(),
							city: storeDetails[3].split(',')[0].trim(),
							state: storeDetails[4],
							zipcode: zipCode,
							storeHours: storeHours
						}
				}
			}

			return store;
		},

		 /**
     * @function getUserStore
     * @description If HD is accessed from one of the store location, this method returns the store
     * from where the user has accessed HD.com
     * @return {object} Store details
     */
		getUserStore: function() {
			var store = repositoryService.get('THD_STORE_INFO');
			if(!store) {
				return undefined;
			}
			var storeDetails = store.split('+');
			return {
				storeId: storeDetails[0],
				name: storeDetails[1].split('-')[0].trim(),
				city: storeDetails[1].split('-')[1].split(',')[0].trim(),
				state: storeDetails[1].split('-')[1].split(',')[1].trim()
			}
		},

		/**
		 * @function RemoveStore
		 * @description Removes the store details from the storage.
		 * @param {string} storageStrategy Optional parameter allows consumer to specify the storage method.
		 * @return {boolean} true if store details successfully removed else false.
		 */
		removeStore: function() {
			var workflow = userService.status.getWorkflow();
			repositoryService.remove(storeStorageKey, workflow);
		}
	}

	return storeService;
});



//////////////////
// WEBPACK FOOTER
// ./src/storeService.js
// module id = 8
// module chunks = 0